import { render, staticRenderFns } from "./carousel-edit.vue?vue&type=template&id=6e3bbd8f&scoped=true&"
import script from "./carousel-edit.vue?vue&type=script&lang=js&"
export * from "./carousel-edit.vue?vue&type=script&lang=js&"
import style0 from "./carousel-edit.vue?vue&type=style&index=0&id=6e3bbd8f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3bbd8f",
  null
  
)

export default component.exports